import { Brand, createBranded } from '@deltasierra/type-utilities';
import { Base64Data } from './files';

export type Url = Brand<string, 'Url'>;
export const Url = createBranded<Url>();

/**
 * Check is a URL is valid. This implementation from SO is a little controversial as it doesn't handle some cases.
 *
 * @example
 * isValidUrl('www.google.com') // True
 * isValidUrl('asdasd') // False
 * isValidUrl('https://web.archive.org/web/20170817095211/github.com/Microsoft/vscode/issues/32405') // False - this is incorrect
 * @param url - The URL to check
 * @returns Whether or not the URL is valid
 * @see https://stackoverflow.com/a/5717133
 */
export function isValidUrl(url: string): boolean {
    const pattern = new RegExp(
        '^(https?:\\/\\/)?' + // Protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // Domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // Port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // Query string
            '(\\#[-a-z\\d_]*)?$',
        'i',
    ); // Fragment locator
    return !!pattern.test(url);
}

export type RelativeUrl = Brand<string, 'RelativeUrl'>;
export const RelativeUrl = createBranded<RelativeUrl>();

export type ProtocolRelativeUrl = Brand<string, 'ProtocolRelativeUrl'>;
export const ProtocolRelativeUrl = createBranded<ProtocolRelativeUrl>(
    (protocolRelativeUrl: string) => protocolRelativeUrl.replace(/^https?:/, '') as ProtocolRelativeUrl,
);

export function protocolRelativeUrlToHttpsUrl(url: ProtocolRelativeUrl): Url {
    return Url.from(`https:${url}`);
}

export type SignedUrl = Brand<string, 'SignedUrl'>;
export const SignedUrl = createBranded<SignedUrl>();

export type ObjectUrl = Brand<string, 'ObjectUrl'>;
export const ObjectUrl = createBranded<ObjectUrl>();

export type FileUrl = Brand<string, 'FileUrl'>;
export const FileUrl = createBranded<FileUrl>();

export type Base64DataUrl = Brand<string, 'Base64DataUrl'>;
export const Base64DataUrl = createBranded<Base64DataUrl>();

export function base64DataToBase64DataUrl(base64Data: Base64Data, mimeType: string): Base64DataUrl {
    return Base64DataUrl.from(`data:${mimeType};base64,${base64Data}`);
}

export type EmailAddress = Brand<string, 'EmailAddress'>;
export const EmailAddress = createBranded<EmailAddress>();

export type Html = Brand<string, 'Html'>;
export const Html = createBranded<Html>();
